import { ConfigProvider, App as AntApp } from "antd";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./providers";
import Theme from "./themes";
import Routes from "./routes";

const App = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: Theme.light.colors.primary,
          colorPrimaryHover: Theme.light.colors.primaryHover,
          colorPrimaryActive: Theme.light.colors.primaryHover,
          colorLink: Theme.light.colors.primary,
          colorError: Theme.light.colors.primary,
          colorText: Theme.light.colors.secondary,
          colorBorder: "#D0D0D0",
          colorBorderSecondary: "#D0D0D0",
          colorSplit: "#D0D0D0",
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          borderRadius: 14,
          borderRadiusLG: 14,
        },
      }}
    >
      <AppProvider>
        <BrowserRouter>
          <AntApp>
            <Routes />
          </AntApp>
        </BrowserRouter>
      </AppProvider>
    </ConfigProvider>
  );
};

export default App;
